import { Card, CardContent, Container, Grid, MenuItem, Paper, Select } from "@mui/material";
import { TrueffortTextField } from "../../MUIstyle/MUICustom";
import { KeyboardArrowDown } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export default function RelatedUsers({ users, setRelations, relations, api }: { users: any, setRelations: any, relations: any, api:string }) {
  const { t } = useTranslation();
  
  return (
    <>{relations.length > 0 ? 
        <Card elevation={2} style={{maxHeight: '30em', overflowY:'auto', height:'100%'}}>
          <CardContent>
            <span >{t("Herramienta.related_users").replace("{0}", api)}</span>
            <Grid style={{paddingTop:'1em'}} container spacing={1}>
            <Grid item sm={4} xs={6}>{"Usuarios " + api}</Grid>
              <Grid item sm={8} xs={6}>{"Usuarios Trueffort"}</Grid>
            {relations.map((ua: any, ind: number) => 
              <>
              <Grid item sm={4} xs={6}><TrueffortTextField
                disabled
                value={ua.name}
                fullWidth
                size='small'
              /></Grid>
              <Grid item sm={8} xs={6}>
                <Select
                  id="project-type-select"
                  name="Project"
                  size="small"
                  sx={{ backgroundColor: '#F5F5F5', color: '#07074E' }}
                  IconComponent={KeyboardArrowDown}
                  displayEmpty
                  fullWidth
                  value={ua.idUser}
                  onChange={(e) => {
                    let us = users.find((u:any) => u.idUser == e.target.value);
                    let items = relations.flat();
                    items[ind].idUser = us?.idUser || '';
                    items[ind].email = us?.email || '';
                    if (e.target.value != ""){
                      let verifyItems = items.filter((it:any) => it.idUser == e.target.value);
                      items[ind].error = verifyItems.length > 1 ? 'Verifique el usuario seleccionado, existe mas de un usuario relacionado al usuario de ' + api : ''
                    }
                    console.log(items);
                    setRelations(items);
                  }}
                >
                  <MenuItem
                    key={""}
                    value={""}
                  >
                    {"Ninguno"}
                  </MenuItem>
                  {users.map((pro: any, k: any) => (
                    <MenuItem
                      key={pro.idUser}
                      value={pro.idUser}
                    >
                      {pro.fullName}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              {ua.errors != "" && <Grid item sm={12}>
                <span className="text-danger">{ua.error}</span>
                </Grid>}
            </>)}
            </Grid>
          </CardContent>
        </Card> :
        <Card style={{minHeight: '100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
          <CardContent>
          <span >{"No se encontraron usuarios asignados a las tareas de este proyecto"}</span>
          </CardContent>
        </Card>  
      }
    </>
  );
}